import { fade } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { get } from 'global/lib/lodash';

const getColor = (props, theme, key) => {
  let color = props.bgColor;
  if (props.disabled || props.variant === 'outlined' || props.variant === 'none') {
    return undefined;
  }
  if (props.variant === 'default') {
    color = 'rgba(0,0,0,0.0)';
  } else if (props.bgColor === 'primary' || props.bgColor === 'secondary') {
    color = get(theme.palette, [props.bgColor]);

    if (key) {
      color = get(color, key);
    }
  }

  return color;
};

const getFade = (props, theme) => {
  const color = getColor(props, theme);

  if (props.variant === 'default' || props.disabled || props.variant === 'outlined' || props.variant === 'none') {
    return get(theme, 'palette.action.hover');
  }
  if (typeof color === 'string') {
    return fade(color, 0.9);
  }
  return get(color, 'light');
};

const getContrastText = (props, theme) => {
  const color = getColor(props, theme);

  if (props.disabled || props.variant === 'outlined' || props.variant === 'none') {
    return undefined;
  } else if (props.variant === 'default') {
    return get(theme.palette, [props.color || 'primary', 'main']);
  }
  if (typeof color === 'string') {
    return theme.palette.getContrastText(color);
  }

  return color.contrastText;
};

const useStyles = makeStyles((theme) => ({
  root: {
    color: (p) => p.textColor || getContrastText(p, theme),
    backgroundColor: (p) => getColor(p, theme, 'main'),
    '&:hover': {
      backgroundColor: (p) => getFade(p, theme),
    },
    '& .MuiCircularProgress-root': {
      color: (p) => getContrastText(p, theme),
      marginLeft: theme.spacing(1),
    },
  },
}));

export default useStyles;
